(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    var KEY = 'sumo_cookie_consent';
    var banner = document.querySelector('[data-cookie-banner]');
    if (!banner) return;
    var stored = null;
    try { stored = localStorage.getItem(KEY); } catch (e) {}
    if (stored) return;
    banner.hidden = false;
    requestAnimationFrame(function () { banner.classList.add('is-visible'); });

    function choose(granted) {
      try {
        if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
          window.Shopify.customerPrivacy.setTrackingConsent(
            { analytics: granted, marketing: granted, preferences: granted, sale_of_data: granted },
            function () {}
          );
        }
      } catch (e) {}
      try { localStorage.setItem(KEY, granted ? 'accepted' : 'declined'); } catch (e) {}
      banner.classList.remove('is-visible');
      setTimeout(function () { banner.hidden = true; }, 320);
    }
    var a = banner.querySelector('[data-cookie-accept]');
    var d = banner.querySelector('[data-cookie-decline]');
    if (a) a.addEventListener('click', function () { choose(true); });
    if (d) d.addEventListener('click', function () { choose(false); });
  })();
  } catch(e) { console.error(e); }
})();

})();
